document.addEventListener("DOMContentLoaded", () => {
  if (!window.gsap) return;

  gsap.registerPlugin(ScrollTrigger);

  /* ===============================
     GLOBAL FADE UP (Reusable)
  =============================== */

  gsap.utils.toArray(".animate-on-scroll").forEach((el) => {
    gsap.from(el, {
      opacity: 0,
      y: 40,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        toggleActions: "play none none none"
      }
    });
  });


  /* ===============================
     HERO / LARGE HEADLINES
  =============================== */

gsap.utils.toArray("h1, h2").forEach((heading) => {
  gsap.fromTo(
    heading,
    { opacity: 0, y: 60 },
    {
      opacity: 1,
      y: 0,
      duration: 1.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: heading,
        start: "top 90%",
        toggleActions: "play none none none"
      }
    }
  );
});


const frameworkCards = document.querySelectorAll(".framework-card");

if (frameworkCards.length) {
  gsap.fromTo(
    frameworkCards,
    {
      opacity: 0,
      y: 60
    },
    {
      opacity: 1,
      y: 0,
      duration: 0.9,
      ease: "power3.out",
      stagger: 0.25,
      scrollTrigger: {
        trigger: ".framework-cards",
        start: "top 80%",
        toggleActions: "play none none none"
      }
    }
  );
}

  /* ===============================
     INSIDE BOOK LIST STAGGER
  =============================== */

const bookList = document.querySelector(".inside-book-list");

if (bookList) {
  gsap.fromTo(
    bookList.children,
    { opacity: 0, y: 30 },
    {
      opacity: 1,
      y: 0,
      duration: 0.8,
      stagger: 0.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: bookList,
        start: "top 85%",
        toggleActions: "play none none none"
      }
    }
  );
}



  /* ===============================
     CTA SECTION
  =============================== */

  const finalCTA = document.querySelector(".final-cta-inner");
  if (finalCTA) {
    gsap.from(finalCTA, {
      opacity: 0,
      scale: 0.98,
      duration: 1.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: finalCTA,
        start: "top 85%"
      }
    });
  }


  /* ===============================
     BUTTON MICRO INTERACTION
  =============================== */

  gsap.utils.toArray(".cta-actions a, .cta-actions button").forEach((btn) => {
    btn.addEventListener("mouseenter", () => {
      gsap.to(btn, {
        y: -3,
        duration: 0.3,
        ease: "power2.out"
      });
    });

    btn.addEventListener("mouseleave", () => {
      gsap.to(btn, {
        y: 0,
        duration: 0.3,
        ease: "power2.out"
      });
    });
  });


  /* ===============================
     FOOTER FADE IN
  =============================== */

  const footer = document.querySelector(".site-footer");
  if (footer) {
    gsap.from(".footer-inner > *", {
      opacity: 0,
      y: 30,
      duration: 1,
      stagger: 0.15,
      ease: "power3.out",
      scrollTrigger: {
        trigger: footer,
        start: "top 90%"
      }
    });
  }


  /* ===============================
     OPTIONAL PARALLAX (SUBTLE)
  =============================== */

  gsap.utils.toArray(".final-cta").forEach((section) => {
    gsap.to(section, {
      backgroundPosition: "50% 60%",
      ease: "none",
      scrollTrigger: {
        trigger: section,
        scrub: true
      }
    });
  });

});
